import { useDispatch } from 'react-redux'

const useThunkDispatch = () => {
  const dispatch = useDispatch()
  return f => f(dispatch)
}

export default useThunkDispatch
